/**
 * Shopper Intent Tracker
 *
 * Composes individual intent trackers and fires custom DOM events
 * when certain "indecisive" shopper behaviors are detected.
 */

import { memo, useEffect } from "react";
import { setupImageBrowsingTracker } from "./shopper-intent/image-browsing";
import { setupProductComparisonTracker } from "./shopper-intent/product-comparison";
import { cleanupNavigationListener } from "./shopper-intent/types";
import { setupVariantIndecisionTracker } from "./shopper-intent/variant-indecision";

export { ShopperIntentEvent } from "./shopper-intent/types";

export const ShopperIntentTracker = memo(function ShopperIntentTracker() {
  useEffect(() => {
    const variantTracker = setupVariantIndecisionTracker();
    const productTracker = setupProductComparisonTracker();
    const imageTracker = setupImageBrowsingTracker();

    return () => {
      variantTracker.cleanup();
      productTracker.cleanup();
      imageTracker.cleanup();
      cleanupNavigationListener();
    };
  }, []);

  return null;
});
